import getYandexMap from '../maps/map';
import initYandexMap from './map/initialize';
import errorHandler from './map/error-handler';

window.addEventListener('scroll', () => getYandexMap(initYandexMap, errorHandler), {once: true});
